<div class="modal-questionnaire-box" *ngIf="questionnaireForm">
    <app-questionnaire [form]="questionnaireForm" [formKeys]="formKeys"
        [questionnaire]="questionnaire" [newLiquidationSubjects]="newLiquidationSubjects"
        (viewSubject)="onViewSubject($event)"
        (deleteSubject)="onDeleteSubject($event)"
        (newLiquidationSubjectsChange)="onNewLiquidationSubjectsChange($event)">
    </app-questionnaire>
    <div class="d-flex justify-content-between mt-3">
        <button mat-raised-button [color]="'warn'" (click)="close(false)">Chiudi</button>
        <button mat-raised-button [color]="'primary'" [disabled]="!isQuestionnaireFormValid || isReadOnly" (click)="close(true)">Conferma</button>
    </div>
</div>
